import moment from "moment";
import { useState } from "react";

import { isDateBetween } from "@utils";

import "./style.scss";

const RatesTableComponent = ({ items, handleRemoveItem = () => {} }) => {
    const [all, setAll] = useState(false);

    return (
        <div className="rates-traffic-table">
            <div className="table__head">
                <span>Период действия</span>
                <span>Стоимость с НДС</span>
                <span>Стоимость без НДС</span>
                <span>Комментарий</span>
            </div>

            {items.slice(0, all ? items.length : 2).map((item, idx) => {
                const isGreen = isDateBetween(item.dateStart, item.dateEnd || new Date());

                return (
                    <div className={`table__body ${isGreen ? "green" : ""}`} key={idx}>
                        {item.indefinitely ? (
                            <div className="date">
                                <span>
                                    <span>с</span> {moment(item.dateStart).format("DD.MM.YYYY")}
                                </span>
                            </div>
                        ) : (
                            <div className="date">
                                <span>
                                    <span>с</span> {moment(item.dateStart).format("DD.MM.YYYY")}
                                </span>
                                <span>
                                    <span>до</span> {moment(item.dateEnd).format("DD.MM.YYYY")}
                                </span>
                            </div>
                        )}
                        <span>{Number(item.priceWithNds).toFixed(2)} ₽</span>
                        <span>{(item.priceWithNds / 1.2).toFixed(2)} ₽</span>
                        <span>{item.comments}</span>

                        <i className="pi pi-trash" style={{ color: "#FF3D32", cursor: "pointer" }} onClick={() => handleRemoveItem(item._id)}></i>
                    </div>
                );
            })}

            {items.length > 2 ? (
                <div className="table__button" onClick={() => setAll(!all)}>
                    {all ? "Скрыть ставки" : "Показать еще"}
                </div>
            ) : null}
        </div>
    );
};

export default RatesTableComponent;
